import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KYMW7007Model } from './kymw7007.model';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { VersatileComboBoxComponent } from '../../../commons/kymw02/combo-box/versatile-combo-box/versatile-combo-box.component';
import { GetRequestListInfoService } from './api-services/get-request-list-info.service';
import { GetDelivCatalogIdByOrderCodeService } from './api-services/get-deliv-catalog-id-by-order-code.service';
import { GetOrderCodeByDelivCatalogIdService } from './api-services/get-order-code-by-deliv-catalog-id.service';
import { GetOrderCodeMediumListService } from './api-services/get-order-code-medium-list.service';
import { CellType, FlexGrid } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';


/**
 * 表紙・特集商品選定依頼確認（担当バイヤー用）画面を管理するクラス
 *
 * @export KYMW7007Component
 * @class KYMW7007Component
 */
@Component({
  selector: 'app-kymw7007',
  templateUrl: 'kymw7007.component.html',
  styleUrls: ['kymw7007.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW7007Component
  extends PlessViewHelperSub
  implements OnInit
{
  public model: KYMW7007Model = new KYMW7007Model();
  private contextMenu: Menu;
  private isEditOrderCode = false;
  private isEditCatalogId = false;

  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: ElementRef;
  @ViewChild('txti_CatalogId', { static: true }) txti_CatalogId: ElementRef;
  @ViewChild('cmb_MediumType', { static: true }) public cmb_MediumType: VersatileComboBoxComponent;
  @ViewChild('dtg_RequestInfoList', { static: true }) dtg_RequestInfoList: FlexGrid;
  @ViewChild('btn_Display', { static: true }) btn_Display: ElementRef;

  /**
   * Creates an instance of KYMW7007Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetRequestListInfoService} getRequestListInfoService
   * @param {GetDelivCatalogIdByOrderCodeService} getDelivCatalogIdByOrderCodeService
   * @param {GetOrderCodeByDelivCatalogIdService} getOrderCodeByDelivCatalogIdService
   * @param {GetOrderCodeMediumListService} getOrderCodeMediumListService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW7007Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getRequestListInfoService: GetRequestListInfoService,
    private getDelivCatalogIdByOrderCodeService: GetDelivCatalogIdByOrderCodeService,
    private getOrderCodeByDelivCatalogIdService: GetOrderCodeByDelivCatalogIdService,
    private getOrderCodeMediumListService: GetOrderCodeMediumListService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW7007Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW7007';
    this.setContextMenu();
    this.route.queryParams.subscribe((params) => {
      // 遷移元が表紙・特集掲載商品選定（バイヤー）の場合のパラメータ取得
      if ('orderCode' in params) {
        this.model.orderCode = params['orderCode'];
      }
      if ('mediumType' in params) {
        // 受注コード設定によりイベントハンドラが動いて媒体がクリアされるので遅延評価
        // 受注コードの有効無効判定を期待動作させるためにも遅延評価が必要
        setTimeout(() => {
          this.model.mediumType = params['mediumType'];
          this.changeDisplayButtonEnabled();
          this.displayButtonClickHandler();
        }, 500);
      }
    });
  }

  /**
   * コンテキストメニュー初期化
   *
   * @memberof KYMW7007Component
   */
  private setContextMenu() {
    this.contextMenu = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '商品選定', cmd: 'featureGoods', enabled: true },
      ],
      command: this.getFormatMenuCommand(),
      itemClicked: () => {
        switch (this.contextMenu.selectedValue) {
          case 'featureGoods':
            this.featureGoodsClickHandler();
            break;
        }
      }
    });
    this.dtg_RequestInfoList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        this.contextMenuSelectHandler(e);
        // メニュー表示
        this.contextMenu.show(e);
      }
    });
  }

  /**
   * コンテキストメニュー活性制御
   *
   * @memberof KYMW7007Component
   */
  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * コンテキストメニュー 選択
   *
   * @memberof KYMW7007Component
   */
  private contextMenuSelectHandler(e: any): void {
    const ht = this.dtg_RequestInfoList.hitTest(e.pageX, e.pageY);

    // コンテキストメニューの利用可能不可判断フラグ
    let contextMenuEnabledMode = true;
    // グリッドのセル外または選択行がない場合はコンテキストメニューを非活性
    if (ht.cellType !== CellType.Cell || (PlessViewUtilsSub.isEmptyArray(this.dtg_RequestInfoList.selectedRows))) {
      contextMenuEnabledMode = false;
      this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
        item.enabled = contextMenuEnabledMode;
      });
    } else {
      this.setDataGridContextMenuEnabled(this.contextMenu, this.dtg_RequestInfoList.selectedRows[0]);
    }
  }

  /**
   * コンテキストメニュー 表示時
   *
   * @private
   * @param {Menu} contextMenu コンテキストメニュー
   * @param {*} selectedRow 現在選択されている行
   * @memberof KYMW7007Component
   */
  private setDataGridContextMenuEnabled(contextMenu: Menu, selectedRow: any) {
    if (selectedRow.dataItem.requestStatus === '0' || selectedRow.dataItem.requestStatus === '1') {
      contextMenu.itemsSource[0].enabled = true;
    } else {
      contextMenu.itemsSource[0].enabled = false;
    }
  }

  /**
   * コンテキストメニュー 商品選定 クリック
   *
   * @memberof KYMW7007Component
   */
  private featureGoodsClickHandler() {
    this.router.navigate(['/kymw/7001'], {
      queryParams: {
        orderCode: this.model.displaySucceededOrderCode,
        catalogId: this.model.displaySucceededCatalogId,
        mediumType: this.model.displaySucceededMediumType,
        featureCode: this.dtg_RequestInfoList.selectedRows[0].dataItem.featureCode,
        buyerRequestId: this.dtg_RequestInfoList.selectedRows[0].dataItem.buyerRequestId
      },
    });
  }

  /**
   * 受注コード 変更
   *
   * @memberof KYMW7007Component
   */
  public orderCodeChangedHandler() {
    if (this.isEditCatalogId) {
      return;
    }
    this.isEditOrderCode = true;
    if (this.model.orderCode.length === 7) {
      this.getDelivCatalogIdByOrderCodeService.execute(this.model, () => {
        if (this.model.catalogId !== '') {
          this.cmb_MediumType.disabled = false;
          if (this.model.mediumTypeList.length === 0) {
            this.getOrderCodeMediumListService.execute(this.model);
          }
        }
      });
    } else {
      this.model.catalogId = '';
      this.model.mediumType = '';
      this.model.mediumTypeList = [];
      this.cmb_MediumType.disabled = true;
      this.clearDisplay();
    }

    this.changeDisplayButtonEnabled();
    setTimeout(() => {
      this.isEditOrderCode = false;
    });
  }

  /**
   * 企画回 変更
   *
   * @memberof KYMW7007Component
   */
  public catalogIdChangedHandler() {
    if (this.isEditOrderCode) {
      return;
    }
    this.isEditCatalogId = true;
    if (this.model.catalogId.length === 8) {
      this.getOrderCodeByDelivCatalogIdService.execute(this.model, () => {
        if (this.model.orderCode !== '') {
          this.cmb_MediumType.disabled = false;
          if (this.model.mediumTypeList.length === 0) {
            this.getOrderCodeMediumListService.execute(this.model);
          }
        }
      });
    } else {
      this.model.orderCode = '';
      this.model.mediumType = '';
      this.model.mediumTypeList = [];
      this.cmb_MediumType.disabled = true;
      this.clearDisplay();
    }

    this.changeDisplayButtonEnabled();
    setTimeout(() => {
      this.isEditCatalogId = false;
    });
  }

  /**
   * 媒体 変更
   *
   * @memberof KYMW7007Component
   */
  public mediumTypeChangedHandler() {
    this.clearDisplay();
    this.changeDisplayButtonEnabled();
  }

  /**
   * 表示クリア
   *
   * @memberof KYMW7007Component
   */
  private clearDisplay() {
    this.model.requestInfoList = [];
  }

  /**
   * 表示ボタン 活性/非活性の制御
   *
   * @memberof KYMW7007Component
   */
  private changeDisplayButtonEnabled() {
    if (this.model.orderCode !== '' && this.model.mediumType !== '') {
      this.btn_Display.nativeElement.disabled = false;
    } else {
      this.btn_Display.nativeElement.disabled = true;
    }
  }

  /**
   * 表示ボタン 押下
   *
   * @memberof KYMW7007Component
   */
  public displayButtonClickHandler() {
    this.getRequestListInfoService.execute(this.model, () => {
      if (this.model.requestInfoList.length === 0) {
        // 検索結果が0件です
        this.dialogService.openAlertGetMessage('W0049');
      } else {
        this.model.displaySucceededOrderCode = this.model.orderCode;
        this.model.displaySucceededCatalogId = this.model.catalogId;
        this.model.displaySucceededMediumType = this.model.mediumType;
      }
    });
  }
}
